<template>
  <b-card>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="loadingState"
    >
      <b-row>
        <b-col md="6">
          <zones-list
            @zones-loading-state="loadingState = $event"
            @zone-selected="onZoneSelected"
          />
        </b-col>
        <b-col md="6">
          <services-list
            v-if="selectionInfo.zone"
            :selection-info="selectionInfo"
            @services-loading-state="loadingState = $event"
            @service-selected="onServiceSelected"
          />
        </b-col>
        <b-col md="12">
          <b-button
            variant="primary"
            :disabled="!selectionInfo.zone || !selectionInfo.service"
            @click="handleAddVersion"
          >
            Next
          </b-button>
        </b-col>
      </b-row>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BOverlay, BCard, BButton, BRow, BCol,
} from 'bootstrap-vue'
import { ref, reactive } from '@vue/composition-api'
import ZonesList from './components/ZonesList.vue'
import ServicesList from './components/ServicesList.vue'

export default {
  components: {
    ZonesList,
    BRow,
    BCol,
    ServicesList,
    BOverlay,
    BCard,
    BButton,
  },
  setup(props, ctx) {
    const loadingState = ref(true)
    const selectionInfo = reactive({
      zone: null,
      service: null,
    })
    const onZoneSelected = event => {
      selectionInfo.zone = event
      selectionInfo.service = null
    }
    const onServiceSelected = event => {
      if (event) {
        selectionInfo.service = {
          service: event.service,
          serviceClass: event.serviceClass,
        }
      } else {
        selectionInfo.service = null
      }
    }

    const handleAddVersion = () => {
      ctx.root.$router.push({
        path: '/businesses/versions/new',
        query: {
          zone: selectionInfo.zone,
          service: selectionInfo.service.service,
          'service-class': selectionInfo.service.serviceClass,
          businessId: ctx.root.$route.query.businessId,
        },
      })
    }

    return {
      selectionInfo,
      loadingState,
      handleAddVersion,
      onZoneSelected,
      onServiceSelected,
    }
  },
}
</script>

  <style>

  </style>
